export default __webpack_public_path__ + "static/media/1d05ff605f5b4226d2074b94867c0f51.svg";